import script from "./ComparisonChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ComparisonChart.vue?vue&type=script&setup=true&lang=js"

import "./ComparisonChart.vue?vue&type=style&index=0&id=b3c66a4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3c66a4e"]])

export default __exports__